import { Injectable } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PreviousUrlService {
  private previousUrl: string | null = null;
  private currentUrl: string | null = null;
  private initialNavigation = true;
  constructor(private router: Router) {
    this.previousUrl = this.extractPathFromReferrer();
    this.currentUrl = window.location.pathname;
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => {
        this.previousUrl = this.currentUrl;
      });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.currentUrl = window.location.pathname;
      });
  }

  private extractPathFromReferrer(): string | null {
    const referrer = document.referrer;
    if (!referrer) return null;
    const url = new URL(referrer);
    if (url.origin === window.location.origin) {
      return url.pathname;
    }
    return null;
  }

  getPreviousUrl(): string | null {
    return this.previousUrl;
  }
}
